module.exports = __webpack_public_path__ + "img/icon-star4.1286461c.png";